export const getRepositoryLabel = (repositoryName: string): string =>
  repositoryName.split('/').slice(2).join('/') || repositoryName;
